// Names of the external carriers that can handle an order (order.handledBy 'external', by order.externalCarrierId)
const externalCarrierNames: Record<string, string> = {
    idl: 'IDL'
}

export default externalCarrierNames
